// extracted by mini-css-extract-plugin
var _1 = "Pxkge";
export { _1 as "button" }
